<template>
  <ul :class="$style.list">
    <li :class="$style.list__item" v-for="preset in PRESETS" :key="preset.key">
      <RouterLink
        :class="[$style.link, $style[`link--preset${preset.key}`]]"
        :to="preset.to"
        >{{ preset.text }}</RouterLink
      >
    </li>
  </ul>
</template>

<script setup lang="ts">
import {
  toQueryParams,
  DEFAULT_FORM_STATE,
} from '../hooks/useKarteUserFilteringRule'

type Rule = Partial<Parameters<typeof toQueryParams>[0]>
const createTo = (rule: Rule) => ({
  name: 'karteList' as const,
  query: toQueryParams({
    ...DEFAULT_FORM_STATE,
    ...rule,
  }),
})

const PRESETS = [
  {
    key: 1,
    text: '保険募集人の皆様におすすめ',
    // 世帯年収600万円以上、預貯金は30万円以上 かつ、コメントあり
    to: createTo({
      annualIncome: {
        min: 6000000,
        max: null,
      },
      hasConcern: 'existConcern',
    }),
  },
  {
    key: 2,
    text: '特に女性の相談に乗りたい保険募集人の皆様におすすめ',
    // 世帯年収600万円以上、預貯金は30万円以上 かつ、コメントあり
    to: createTo({
      annualIncome: {
        min: 3000000,
        max: 6000000,
      },
      sex: 'female',
      generation: [0],
      hasConcern: 'existConcern',
    }),
  },
  {
    key: 3,
    text: 'IFAの皆様におすすめ',
    // 総資産2000万円以上 かつ、コメントあり
    to: createTo({
      totalAssets: {
        min: 20_000_000,
        max: null,
      },
      hasConcern: 'existConcern',
    }),
  },
]
</script>

<style lang="scss" module>
.list {
  display: flex;
  align-items: center;
  gap: 16px;
}

.link {
  display: flex;
  width: 310px;
  height: 160px;
  align-items: flex-end;
  padding: 12px;
  background: center/contain no-repeat;
  border-radius: 12px;
  box-shadow: $shadow-20;
  color: $color-text-and-object-high-emphasis-inverse;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.5;

  &:hover {
    opacity: 0.8;
    text-decoration: none;
  }

  &--preset1 {
    background-image: url('./assets/preset1.jpg');
  }

  &--preset2 {
    background-image: url('./assets/preset2.jpg');
  }

  &--preset3 {
    background-image: url('./assets/preset3.jpg');
  }
}
</style>
